import { useTranslation } from "@redotech/redo-i18n";
import ChevronUpIcon from "@redotech/redo-icons/chevron-up.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import * as css from "./collapse-toggle.module.css";

/** State for a flow node whose subtree can be hidden or shown. */
export interface CollapsibleNodeData {
  isCollapsed?: boolean;
  toggleCollapse?: () => void;
  descendantCount?: number;
}

/** Compact expand/collapse control for branching flow nodes. */
export const CollapseToggle = memo(function CollapseToggle({
  isCollapsed = false,
  toggleCollapse,
  descendantCount = 0,
}: CollapsibleNodeData) {
  const { t } = useTranslation();

  if (!toggleCollapse) {
    return null;
  }

  return (
    <Flex
      align="center"
      aria-label={
        isCollapsed
          ? t("Expand {{count}} hidden nodes", { count: descendantCount })
          : t("Collapse subtree")
      }
      as="button"
      className={css.edgeToggle}
      justify="center"
      onClick={(e) => {
        e.stopPropagation();
        toggleCollapse();
      }}
      p="none"
      type="button"
    >
      {isCollapsed && descendantCount > 0 ? (
        <Text fontSize="xxs" fontWeight="medium">
          {descendantCount}
        </Text>
      ) : (
        <ChevronUpIcon className={css.chevronIcon} />
      )}
    </Flex>
  );
});
